import { render, staticRenderFns } from "./ForgotMail.vue?vue&type=template&id=a5049f8e&"
import script from "./ForgotMail.vue?vue&type=script&lang=js&"
export * from "./ForgotMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports